// hooks/useLocationFetching.tsx
import { useCallback } from "react";
import { getCurrentLocation, getLocation } from "../../../utils/CommonFunctions";
import useGeocoding from "./useGeocoding";

const useLocationFetching = () => {
  const { getGeocoding } = useGeocoding();

  const fetchLocationWithGeocoding = useCallback(async (
    onSuccess: (locationData: any) => void,
    onError: (locationData: any) => void
  ) => {
    if (!window.config) {
      console.error("App config not loaded yet. Please try again.");
      return;
    }
    
    try {
      // Use getCurrentLocation directly with async/await
      const coords = await getLocation();
      const { latitude, longitude } = coords;
      
      // Add a small delay to ensure coordinates are stable
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Get FSA from coordinates
      let fsa = "";
      try {
        fsa = await getGeocoding(latitude, longitude, 3);
      } catch (error: any) {
        console.warn("Failed to get FSA from coordinates:", error);
      }
      
      const locationWithFSA = { 
        latitude, 
        longitude, 
        fsa: fsa || "",
        timestamp: Date.now()
      };
      
      onSuccess(locationWithFSA);
    } catch (error: any) {
      const defaultLocation = {
        longitude: window.config?.default_location?.longitude || -79.45306,
        latitude: window.config?.default_location?.latitude || 44.06056,
        radius: window.config?.default_location?.radius || 10,
        fsa: "L3Y"
      };
      console.error("Error getting location:", error.message, " -- setting default location");
      onError(defaultLocation);
    }
  }, [getGeocoding]);

  return { fetchLocationWithGeocoding };
};

export default useLocationFetching;